import React from 'react';
import { Award, Users, Star } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function AboutSection() {
  const {
    t
  } = useLanguage();
  const values = [{
    icon: <Award className="w-6 h-6 text-brand-gold" data-id="element-20" />,
    title: t('about.v1')
  }, {
    icon: <Users className="w-6 h-6 text-brand-gold" data-id="element-21" />,
    title: t('about.v2')
  }, {
    icon: <Star className="w-6 h-6 text-brand-gold" data-id="element-22" />,
    title: t('about.v3')
  }];
  return <section id="nosotros" className="py-20 lg:py-28 bg-white" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-25">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-26">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-black mb-6 leading-tight" data-id="element-27">
              {t('about.title')}
            </h2>

            <div className="space-y-6 text-lg text-brand-text/80 mb-8" data-id="element-28">
              <p data-id="element-29">{t('about.p1')}</p>
              <p data-id="element-30">{t('about.p2')}</p>
              <p data-id="element-31">{t('about.p3')}</p>
              <p data-id="element-32">{t('about.p4')}</p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-cream border border-black/5 rounded-2xl p-8 md:p-12" data-id="element-33">
            <h3 className="text-2xl font-serif font-bold text-brand-black mb-8 text-center" data-id="element-34">
              {t('about.vTitle')}
            </h3>

            <div className="space-y-6" data-id="element-35">
              {values.map((value, index) => <div key={index} className="flex items-center gap-6 bg-white p-6 rounded-xl shadow-sm border border-black/5" data-id="element-36">
                  <div className="bg-brand-gold/10 p-4 rounded-full flex-shrink-0" data-id="element-37">
                    {value.icon}
                  </div>
                  <span className="text-xl font-bold text-brand-black" data-id="element-38">
                    {value.title}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}